//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

    /**
     * Replace all hashtag occurrences in the given text with a link to the hashtag's Content Discovery detail page. Also inserts a space between
     * consecutive hashtags if one is not already present (ie: '#tagone#tagtwo' becomes '#tagone #tagtwo', but '#tagone #tagtwo' is unaffected).
     *
     * @param text      The input string containing hashtags. This may be an object if the text has already been run through $sce.trustAsHtml
     * @param prefix    Optional string prefix to the text within the link (default behavior will only create a link for the hashtag name, without '#').
     *
     * @return The input text with all hashtags now linked to their respective Content Discovery hashtag detail pages.
     */
  curalate.filter('hashtag', [
    'StringUtils',
    '$sce',
    function(
            StringUtils,
            $sce,
        ) {
      return function(text, prefix, context) {
        const url = '/explore/instagram/hashtags/';
        let contextParams;

        if (context && context.query) {
          contextParams = `?query=${context.query}${context.queryType ? `&queryType=${context.queryType}` : ''}`;
        } else if (context && context.influencer) {
          contextParams = `?influencer=${context.influencer}`;
        }

        const cb = function(tag, match, offset, string) {
          const href = url + match + (contextParams || '');
          const linktext = (prefix || '') + match;
          let link = `<a target="_self" href="${href}">${linktext}</a>`;
          const nextCharIndex = offset + tag.length;

                    // If the next character in the string is another hashtag, add a space for clarity.
          if (nextCharIndex < string.length && string[nextCharIndex] === '#') {
            link += ' ';
          }

          return link;
        };

        return $sce.trustAsHtml(StringUtils.replaceHashtags($sce.getTrustedHtml(text), cb));
      };
    },
  ]);
})();
